import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';

export const TitleWithIcon = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  marginTop: '-6px',
  color: '#B71C1C',
  '& .material-symbols-outlined': { fontSize: '18px' },
}));

export const List = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  overflowY: 'auto',
  paddingRight: '4px',
}));

export const Item = styled(Link)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
  padding: '8px 12px',
  borderRadius: '6px',
  border: `1px solid ${theme.palette.divider}`,
  fontSize: '12px',
  color: theme.palette.text.primary,
  textDecoration: 'none',
  '&:hover, &:focus-visible': {
    backgroundColor: 'rgba(245, 6, 6, 0.06)',
    borderColor: '#F50606',
    outline: 'none',
  },
  '& strong': { fontSize: '13px' },
  '& .late': { color: '#B71C1C', fontWeight: 600 },
  '& .meta': { color: '#666' },
}));

export const Empty = styled(Typography)(() => ({
  fontSize: '13px',
  color: '#666',
  textAlign: 'center',
  padding: '32px 0',
}));
